// components/DashboardCard.jsx
import { Card, CardContent, Typography, Box, IconButton } from '@mui/material';
import ArrowOutwardIcon from '@mui/icons-material/ArrowOutward';
import { CircleArrowOutUpRight } from 'lucide-react';

const DashboardCard = ({ title, value, subtext, subtextColor, breakTime }) => {
  return (
    <Card
      sx={{
        background: "#fff",
        color: "#000",
        borderRadius: 4,
        minHeight: 180,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        p: 2,
        boxShadow: '6px 6px 15px rgba(0, 0, 0, 0.2)',
        "&:hover": {
          background: "linear-gradient(90deg,rgb(60, 150, 68),rgb(6, 92, 11))",
          color: "#fff"
        }
      }}
    >
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Typography variant="subtitle2" fontSize={12} fontWeight={600}>{title}</Typography>
        <IconButton size="small">
          <CircleArrowOutUpRight color="#000" size={14} strokeWidth={1.75} />
        </IconButton>
      </Box>

      {/* <Typography fontSize={50} fontWeight="500">
        {value}
      </Typography>

      {subtext && (
        <Typography fontSize={10} textAlign={"center"} color={subtextColor || 'text.secondary'}>
          {subtext}
        </Typography>
      )} */}
      {breakTime && breakTime.length > 0 ? (
        breakTime.map((time, index) => (
          <Typography key={index} fontSize={12}>
            ● {time}
          </Typography>
        ))
      ) : (
        <>
          <Typography fontSize={50} fontWeight="500" mb={0}>
            {value}
          </Typography>
          {subtext && (
            <Typography
              fontSize={10}
              textAlign="center"
            >
              {subtext}
            </Typography>
          )}
        </>
      )}


    </Card>
  );
};

export default DashboardCard;
